import { Card } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import Iconify from "src/components/Iconify";
import { ASSETS_COLORS } from "src/theme/palette";

import SquareColor from "./SquareColor";
import SummaryData from "./SummaryData";

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
	display: "flex",
	position: "relative",
	alignItems: "center",
	height: 125,
	padding: theme.spacing(3)
}));

const IconStyle = styled(Iconify)<{ color: string }>(({ theme, color }) => ({
	width: 35,
	height: 35,
	position: "absolute",
	right: theme.spacing(3),
	color: ASSETS_COLORS[color].main
}));

// ----------------------------------------------------------------------

type Props = {
	icon: string;
	title: string;
	color: string;
	value: number;
};

export default function StatisticCard({ title, icon, color, value }: Props) {
	const theme = useTheme();

	return (
		<RootStyle elevation={1} sx={{ py: theme.spacing(3) }}>
			<SummaryData title={title} value={value} />

			<IconStyle color={color} icon={icon} />

			<SquareColor color={color} />
		</RootStyle>
	);
}
